var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inbox-chat"},[_c('p',{staticClass:"text-gray mb-3"},[_vm._v(_vm._s(_vm.$t('chat')))]),_vm._v(" "),_c('app-avatars-group',{attrs:{"avatar-group-class":`avatars-group-w-60`,"avatars":_vm.avatars,"shadow":true,"border":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }